<template>
  <div id="app" ref="app" :class="isWebClass ? 'app-web' : 'app-mobile'">
    <router-view v-if="isWebClass" />
    <div v-else class="landscape-guide">
      <div class="landscape-guide__icon" aria-hidden="true">
        <div class="landscape-guide__phone"></div>
        <div class="landscape-guide__arrow"></div>
      </div>
      <div class="landscape-guide__title">请旋转屏幕为横屏</div>
      <div class="landscape-guide__desc">当前页面需在横屏模式下使用，旋转设备后将自动进入系统。</div>
    </div>
  </div>
</template>

<script>
// import io from 'socket.io-client';
export default {
  name: 'App',
  data() {
    return {
      downY: 0,
      upY: 0,
      isWebClass: null, //根据长宽比确定是用web样式还是移动端样式
    };
  },
  created() {
    //  由于显示问题，在切换横竖屏时页面刷新页面
    // window.addEventListener("orientationchange", function() {
    //   location.reload();
    //   //document.getElementsByTagName('body')[0].style.zoom=2;
    // }, false);

    //在页面加载时读取localStorage里的状态信息
    localStorage.getItem('userMsg') &&
      this.$store.replaceState(Object.assign(this.$store.state, JSON.parse(localStorage.getItem('userMsg'))));

    //在页面刷新时将vuex里的信息保存到localStorage里
    //  window.addEventListener("beforeunload",()=>{
    //      localStorage.setItem("userMsg",JSON.stringify(this.$store.state))
    //  })

    //socket.io获取面试者的登录状态
    // var socket = io(this.socketIoURL,{
    //   path:'/manage'
    // });
    // socket.on('connected',function(){
    //   console.log('connected success!')
    // })
    // socket.on('getInterviewerStatus',(res)=>{
    //   //if(this.$store.state.isVideo){
    //   this.$store.commit('storeInterviewerStatus',res);
    //   //}
    //   console.log(res);
    // })

    //北京时间
    var now = Date.PekingTime();
    this.$store.commit('storeBJTime', now);
    // setInterval(() => {
    //   now += 60000;
    //   this.$store.commit('storeBJTime', now);
    // }, 60000);
    // 每10秒更新一次
    setInterval(() => {
      now += 10000;
      this.$store.commit('storeBJTime', now);
    }, 10000);

    //是否是移动端
    this.updateScreenMode();
  },
  mounted() {
    //全屏、退出全屏事件监听
    const app = this.$refs.app;
    const requestFullScreen = app.webkitRequestFullScreen || app.msRequestFullScreen || app.mozRequestFullScreen;
    const exitFullscreen =
      document.webkitExitFullscreen ||
      document.webkitCancelFullScreen ||
      document.mozCancelFullScreen ||
      document.msExitFullscreen;

    // document.addEventListener("mousedown", (e) => {
    //   this.downY = e.screenY;
    // });
    // document.addEventListener("mouseup", (e) => {
    //   this.upY = e.screenY;
    //   if(this.downY-this.upY>100){
    //     requestFullScreen.call(app)
    //   }else if(this.upY-this.downY>100){
    //     exitFullscreen.call(document)
    //   }
    // });

    //根据宽高比切换web端样式还是移动端样式
    window.addEventListener('resize', this.updateScreenMode);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScreenMode);
  },
  methods: {
    updateScreenMode() {
      const isWebClass = window.innerHeight < window.innerWidth;
      this.isWebClass = isWebClass;
      this.$store.commit('storeIsMobile', !isWebClass);
    },
  },
};
</script>

<style lang="scss" type="text/scss">
@import '~@/assets/scss/element_modify.scss';

$min-width: 992px;
$min-height: 580px;

* {
  word-break: break-all;
  box-sizing: border-box;
  //-webkit-overflow-scrolling: touch;  //解决Safari没有滑动惯性
}

//去除ipad中点击按钮会出现一个半透明的灰色背景的问题
a,
img,
button,
input,
textarea,
div {
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  -webkit-appearance: none;
}

html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  background-color: #f6f7fb;
  font-family:
    ui-sans-serif,
    system-ui,
    -apple-system,
    Segoe UI,
    Roboto,
    Ubuntu,
    Cantarell,
    Noto Sans,
    sans-serif,
    Apple Color Emoji,
    Segoe UI Emoji,
    Segoe UI Symbol,
    Noto Color Emoji;
}

#app {
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  width: 100%;
  background: #f5f7fb;
  font-size: 15px;
}

@media (min-width: 768px) and (max-width: 1024px) {
  #app {
    // font-size: 12px;
  }
}

.app-web {
  height: 100%;
  width: 100%;
  min-width: $min-width;
  min-height: $min-height;
}

.app-mobile {
  height: 100%;
  width: 100%;
}

.landscape-guide {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 32px 24px;
  text-align: center;
  color: #1f2d3d;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.86), rgba(246, 247, 251, 0.96)),
    #f6f7fb;
}

.landscape-guide__icon {
  position: relative;
  width: 116px;
  height: 116px;
  margin-bottom: 28px;
}

.landscape-guide__phone {
  position: absolute;
  top: 25px;
  left: 35px;
  width: 46px;
  height: 66px;
  border: 4px solid #2b6de5;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(43, 109, 229, 0.18);
  transform: rotate(-90deg);
  transform-origin: center;
}

.landscape-guide__phone::after {
  content: '';
  position: absolute;
  bottom: 5px;
  left: 50%;
  width: 10px;
  height: 3px;
  border-radius: 999px;
  background: #2b6de5;
  transform: translateX(-50%);
}

.landscape-guide__arrow {
  position: absolute;
  inset: 12px;
  border: 3px solid rgba(43, 109, 229, 0.24);
  border-left-color: transparent;
  border-bottom-color: transparent;
  border-radius: 50%;
}

.landscape-guide__arrow::after {
  content: '';
  position: absolute;
  top: 5px;
  right: 7px;
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-left: 11px solid #2b6de5;
  transform: rotate(42deg);
}

.landscape-guide__title {
  margin-bottom: 10px;
  font-size: 22px;
  font-weight: 600;
  line-height: 1.35;
}

.landscape-guide__desc {
  max-width: 280px;
  font-size: 15px;
  line-height: 1.7;
  color: #6b778c;
}

@font-face {
  font-family: 'iconfont';
  src: url('~@/assets/fonts/iconfont.eot');
  src:
    url('~@/assets/fonts/iconfont.eot?#iefix') format('embedded-opentype'),
    url('~@/assets/fonts/iconfont.woff') format('woff'),
    url('~@/assets/fonts/iconfont.ttf') format('truetype'),
    url('~@/assets/fonts/iconfont.svg#iconfont') format('svg');
}

.iconfont {
  font-family: 'iconfont' !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}

// 滚动条样式
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(100, 100, 100, 0.3);
  border-radius: 3px;
  transition: background-color 0.3s ease;
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgba(100, 100, 100, 0.5);
}

* {
  scrollbar-width: thin;
  scrollbar-color: rgba(100, 100, 100, 0.3) transparent;
}

html,
body {
  -webkit-overflow-scrolling: touch;
}
</style>
